import type { Network } from '../utils/types';

/**
 * @description 对网速快慢进行判断
 * @param {number} downlink 下行速度
 */
function measureNetwork(downlink: number) {
    if (!downlink) return 'Disconnect';
    const downlinkMbps = downlink / 1024;

    if (downlinkMbps <= 0.5) {
        return 'Slow';
    }
    if (downlinkMbps <= 1.5) {
        return 'Average';
    }
    return 'Fast';
}

// 获取当前的网络环境
export const getNetWorkSituation = (): Promise<Record<string, any>> => {
    return new Promise((resolve) => {
        // downlink 测算网速
        function getSpeedByNavigator() {
            const connection = (window.navigator as Navigator as any).connection;
            if (connection && connection.downlink) {
                const downlink = (connection.downlink * 1024) / 8;
                const speed = measureNetwork(downlink);
                return {
                    effectiveType: connection.effectiveType,
                    downlink: `${downlink}kb`,
                    speed,
                    rtt: connection.rtt,
                };
            }
        }

        type GetSpeedWithAjax = () => Promise<Network>;

        // 通过Ajax测算网速
        const getSpeedWithAjax: GetSpeedWithAjax = () => {
            const url =
                'https://de-prod-style3d.s3-accelerate.amazonaws.com/website/Company/3803b64f-32d9-4796-95c0-c18e31293446/displayhall/image_20230202183420_2965_1675334060194Thumb/1675334060194Thumb.png?st=CFloV9mq7MztVJRtOuLBOVdOTq-yEoj5rMtdivQRioP4VOhxVGRWjzZhKcLZMJWHDboQSVuq36DabBf7XTNUIp01SCjMK1YMJlnWjGpWd7d_AAaY243D2AuOKxD7pOg-DqrFoyJmqLvTJ3C9dmFcscBgPg==';

            function getSpeed() {
                return new Promise((resolve) => {
                    let end = null;
                    const start = new Date().getTime();
                    const xhr = new XMLHttpRequest();
                    xhr.onreadystatechange = function () {
                        if (xhr.readyState === 4) {
                            end = new Date().getTime();
                            const size = Number(xhr.getResponseHeader('Content-Length')) / 1024;
                            const downlink = (size * 1000) / (end - start);
                            const rtt = end - start;
                            resolve({ downlink, rtt });
                        }
                    };
                    xhr.open('GET', url);
                    xhr.send();
                }).catch((err) => {
                    throw err;
                });
            }

            // 多次测速求平均值
            const arr = [];
            for (let i = 0; i < 3; i++) {
                arr.push(getSpeed());
            }

            return Promise.all(arr).then((items: any) => {
                let downlinkSum = 0;
                let rttSum = 0;

                items.forEach((item: Record<string, any>) => {
                    downlinkSum += item.downlink;
                    rttSum += item.rtt;
                });

                const downlink = downlinkSum / 3;

                const speed = measureNetwork(downlink);
                return {
                    downlink,
                    speed,
                    rtt: rttSum / 3,
                };
            });
        };

        const navigatorNetwork = getSpeedByNavigator();

        if (navigatorNetwork) {
            resolve(navigatorNetwork);
        } else {
            getSpeedWithAjax().then((res) => {
                resolve(res);
            });
        }
    });
};
